import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const textAreaV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate text area element to v2',
  run: (props: PartialPropsOf<'textArea'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props?.content?.font, '500');
  },
};
